import type { DropResult } from 'react-beautiful-dnd';

export default {
  handleDragEnd<Item>(items: Array<Item>, result: DropResult): Array<Item> {
    if (!result.destination) {
      return;
    }

    if (
      result.destination.draggableId === result.source.draggableId &&
      result.destination.index === result.source.index
    ) {
      return;
    }

    const reorder = (itemsArray, startIndex, endIndex) => {
      const [removed] = itemsArray.splice(startIndex, 1);
      itemsArray.splice(endIndex, 0, removed);
      return itemsArray;
    };

    reorder(items, result.source.index, result.destination.index);

    return items;
  },
};
